// extracted by mini-css-extract-plugin
export default {"about":"common_about__0y9tT","Icons":"common_Icons__YWRYw"};